<template>
  <a-modal
    v-model="dialogVisible"
    title="申请理赔"
    :mask-closable="false"
    @ok="confirm"
    @cancel="cancel"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-suffix="："
      label-width="100px"
    >
      <el-form-item label="理赔原因" prop="claimReason">
        <el-input
          v-model.trim="form.claimReason"
          type="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 8 }"
          placeholder="请填写"
        />
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input
          v-model.trim="form.contactName"
          maxlength="20"
          placeholder="请填写"
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input
          v-model.trim="form.contactPhone"
          maxlength="20"
          placeholder="请填写"
        />
      </el-form-item>
    </el-form>
  </a-modal>
</template>

<script>
/**
 * @description 线上保函申请理赔（采购人使用）
 */
import { requiredRule } from '@/utils/form-validate'
import { applyOnlineLetterClaimApi } from '@/api/procure/invite-bid'
import { formValid } from 'jczh-ui'

export default {
  name: 'OnlineLetterClaimApply',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    // 订单id
    orderId: {
      type: [String, Number],
      required: true
    },

    // 交易id
    tradeId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      form: {
        // 理赔原因
        claimReason: '',
        // 项目联系人
        contactName: '',
        // 联系电话
        contactPhone: ''
      },
      rules: {
        claimReason: requiredRule('请填写'),
        contactName: requiredRule('请填写'),
        contactPhone: [
          requiredRule('请填写'),
          {
            pattern: formValid.mobileRegular.pattern,
            message: '请输入正确的11位手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    cancel() {
      this.$refs.form.clearValidate()
      this.form = {
        claimReason: '',
        // 项目联系人
        contactName: '',
        // 联系电话
        contactPhone: ''
      }
      this.dialogVisible = false
    },

    confirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const postData = {
          orderId: this.orderId,
          tradeId: this.tradeId,
          ...this.form
        }
        applyOnlineLetterClaimApi(postData)
          .then(res => {
            this.cancel()
            this.$message.success('已申请理赔')
            this.$emit('after-apply')
          })
          .catch(err => {
            console.error('申请理赔失败', err)
            if (err?.message) this.$message.error(err.message)
          })
      })
    }
  }
}
</script>

<style scoped></style>
